/**
 * @param  {Array<T>} elements
 * @returns Map
 */
export function arrayToMap(elements) {
    const ret = {};
    for (const key in elements) {
        if (Object.prototype.hasOwnProperty.call(elements, key)) {
            const element = elements[key];
            ret[element.id] = element;
        }
    }
    return ret;
}
/**
 * @param  {Map<number} elements
 * @returns Map
 */
export function mapToArray(elements) {
    const ret = new Array();
    for (const key in elements) {
        if (Object.prototype.hasOwnProperty.call(elements, key)) {
            const element = elements[key];
            ret.push(element);
        }
    }
    return ret;
}
